<template>
  <b-form-group
    label="Temas Tipi"
    label-for="title"
  >
    <v-select
      v-model="filterData.id_meets"
      :options="meets"
      label="title"
      :reduce="item => item.id"
      placeholder="Seçiniz"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Country',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    filterData() {
      return this.$store.getters['interviews/filterData']
    },
    meets() {
      return this.$store.getters['meets/dataList']
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('meets/getDataList', {
        select: [
          'meets.id AS id',
          'meets.title AS title',
        ],
      })
    },
  },
}
</script>
